<template>
	<div class="newChart" :class="{ whitecolor: colorType == 2 }">
		<div class="check-btn">
			<div
				class="btn-li"
				:class="{ active: index == checkItem }"
				v-for="(x, index) in alist"
				:key="index"
				@click="check(x, index)"
			>
				{{ x.name }}
			</div>
		</div>
		<div class="echarts1">
			<v-chart :options="option" ref="echarts" />
		</div>
	</div>
</template>

<script>
	import xyData from '@/assets/js/area.js'
	import ECharts from 'vue-echarts'
	import 'echarts/lib/chart/bar'
	import 'echarts/lib/component/tooltip'
	import 'echarts/lib/component/legend'
	import 'echarts/lib/component/title'
	import { qyEcharts } from '@/api/index'
	const baseParam = {
		m: process.env.VUE_APP_APPID,
		state: szblMCom.getState(),
		appid: process.env.VUE_APP_APPID,
		rpflag: process.env.VUE_APP_RPFLAG,
	}
	export default {
		name: 'newChart',
		components: {
			'v-chart': ECharts,
		},
		props: {
			datau: {
				type: Object,
			},
			alist: {
				type: Array,
			},
			colorType: {
				type: Number,
			},
		},
		watch: {
			datau: {
				handler(val, oldVal) {
					// console.log(this.$refs.echarts);
					// console.log(this.chart);
					console.log()
					this.$refs.echarts.chart.setOption(this.echartsOption(val))
					// this.$refs.echarts.setOption(val);
				},
				deep: true,
			},
		},
		data: function() {
			return {
				checkItem: 0,
				option: this.echartsOption(this.datau),
			}
		},
		mounted() {
			// this.$nextTick(() => {
			//   this.$refs.echarts.chart.resize({
			//     width: "auto",
			//     height: "auto",
			//   });
			// });
			// this.$refs.echarts.chart.resize({
			//   width: "auto",
			//   height: "auto",
			// });
			// this.$refs.echarts.chart.resize;
		},
		methods: {
			check(item, index) {
				this.checkItem = index
				this.$emit('getData', item.id)
				// this.$refs.echarts.refresh();
			},
			echartsOption(data) {
				let baseColor = '#fff'
				if (this.colorType == 2) {
					baseColor = '#333'
				}
				const option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow',
						},
					},
					grid: {
						left: 40,
						bottom: 40,
						top: 40,
						right: 40,
					},
					toolbox: {
						show: true,
						orient: 'vertical',
						left: 'right',
						top: 'center',
						feature: {
							mark: { show: true },
							dataView: { show: true, readOnly: false },
							magicType: { show: true, type: ['line', 'bar', 'stack'] },
							restore: { show: true },
							saveAsImage: { show: true },
						},
					},
					xAxis: [
						{
							type: 'category',
							axisTick: { show: false },
							data: data.name,
							nameTextStyle: {
								color: baseColor,
							},
							// x轴的字体样式
							axisLabel: {
								rotate: -15,
								show: true,
								textStyle: {
									color: baseColor,
									fontSize: '12',
								},
							},
							//x轴的颜色和宽度
							axisLine: {
								lineStyle: {
									color: baseColor,
								},
							},
						},
					],
					legend: {
						data: ['总隐患', '未整改隐患', '已整改隐患'],
						textStyle: {
							color: baseColor,
						},
					},
					color: [
						'#0e9cff',
						'#fad514',
						'#21e0ba',
						'#21e74b',
						'#e40000',
						'#e77e21',
						'#ce91db',
						'#ade721',
						'#004af1',
						'#f100ee',
					],
					yAxis: [
						{
							type: 'value',
							splitLine: {
								show: false,
								//  改变轴线颜色
								lineStyle: {
									// 使用深浅的间隔色
									color: ['red'],
								},
							},
							//y轴的字体样式
							axisLabel: {
								show: true,
								textStyle: {
									color: baseColor,
								},
							},
							//y轴的颜色和宽度
							axisLine: {
								lineStyle: {
									color: baseColor,
									width: 1, //这里是坐标轴的宽度
								},
							},
						},
					],
					yAxis: [
						{
							type: 'value',

							splitLine: {
								show: false,
								//  改变轴线颜色
								lineStyle: {
									// 使用深浅的间隔色
									color: ['red'],
								},
							},
							//y轴的字体样式
							axisLabel: {
								show: true,
								textStyle: {
									color: baseColor,
								},
							},
							//y轴的颜色和宽度
							axisLine: {
								lineStyle: {
									color: baseColor,
									width: 1, //这里是坐标轴的宽度
								},
							},
						},
					],
					series: (() => {
						const list = data.data
						let newList = []
						for (let item of list) {
							newList.push({
								name: item.name,
								type: 'bar',
								barGap: 0,
								emphasis: {
									focus: 'series',
								},
								lineStyle: {
									color: item.itemColor,
								},
								label: {
									show: true,
									position: 'top',
									textStyle: {
										color: baseColor,
									},
								},
								data: item.data,
							})
						}
						console.log(newList)
						return newList
					})(),
				}
				return option
			},
		},
	}
</script>

<style lang="scss" scoped>
	$white-color: #358fe6;
	$white-bg-color: #fff;
	$white-text-color: #333;
	$white-fz-color: #999;
	.newChart {
		width: 100%;
		height: 100%;
		.check-btn {
			width: calc(100% - 14px);
			// overflow-x: scroll;
			overflow-x: auto;
			white-space: nowrap;
			border: 1px solid #4cbfce;
			margin: auto;
			&::-webkit-scrollbar {
				width: 0;
				height: 0;
			}
			display: flex;
			// padding: 8px;
			// margin-top: 12px;
			background-color: rgba(55, 94, 111);
			align-items: centers;
			box-shadow: 0 0 6px rgb(236, 236, 236);
			// border: #fff;
			.btn-li {
				//   padding: 12px;
				height: 42px;
				flex-shrink: 0;
				line-height: 42px;
				padding: 8px;
				border-left: 1px solid #4cbfce;
				//   border-bottom: 1px solid #4cbfce;
				width: 120px;
				&.active,
				&:hover {
					background-color: rgba(12, 62, 73);
					cursor: pointer;
					box-shadow: 0 0 6px rgb(236, 236, 236);
				}
			}
		}
	}
	.newChart.whitecolor {
		.check-btn {
			border: 1px solid $white-color;
			background-color: #efefef;
			.btn-li {
				border-left: 1px solid $white-color;
				&.active,
				&:hover {
					background-color: $white-color;
					cursor: pointer;
					box-shadow: 0 0 6px rgb(236, 236, 236);
					color: $white-bg-color;
				}
			}
		}
	}
	.echarts1 {
		height: calc(100% - 126px);
		width: 100%;
	}
	.echarts {
		height: 100%;
		width: 60vw;
		position: relative;
		top: 4%;
	}
</style>
